import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=6a2d706c&scoped=true"
import script from "./popover.vue?vue&type=script&lang=ts"
export * from "./popover.vue?vue&type=script&lang=ts"
import style0 from "./popover.vue?vue&type=style&index=0&id=6a2d706c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2d706c",
  null
  
)

export default component.exports